<div class="d-flex justify-content-between">

  <!-- Pagination (prev) -->
  <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
    <li class="page-item">
      <a (click)="previousPage()" [class.fade]="searchTableViewModel.currentPage == 1" [routerLink]=""
        class="page-link ps-0 pe-4 border-end">
        <i class="fe fe-arrow-left me-1"></i> {{ previousPageText }}
      </a>
    </li>
  </ul>

  <!-- Pagination -->
  <ul class="list-pagination pagination pagination-tabs card-pagination">
    @for (pageNumber of getPages(); track pageNumber) {
      <li [class.active]="pageNumber === searchTableViewModel.currentPage">
        <a (click)="setPage(pageNumber)" [routerLink]="" class="page">{{ pageNumber }}</a>
      </li>
    }
  </ul>

  <!-- Pagination (next) -->
  <ul class="list-pagination-next pagination pagination-tabs card-pagination">
    <li class="page-item">
      <a (click)="nextPage()" [class.fade]="hasNextPage() === false" [routerLink]=""
        class="page-link ps-4 pe-0 border-start">
        {{ nextPageText }} <i class="fe fe-arrow-right ms-1"></i>
      </a>
    </li>
  </ul>

  <!-- Alert -->
  <div class="list-alert alert alert-dark alert-dismissible border fade" role="alert">

    <!-- Content -->
    <div class="row align-items-center">
      <div class="col">

        <!-- Checkbox -->
        <div class="form-check">
          <input checked class="form-check-input" disabled id="listAlertCheckbox" type="checkbox">
          <label class="form-check-label text-white" for="listAlertCheckbox">
            <span class="list-alert-count">0</span> deal(s)
          </label>
        </div>

      </div>
      <div class="col-auto me-n3">

        <!-- Button -->
        <button class="btn btn-sm btn-white-20">
          Edit
        </button>

        <!-- Button -->
        <button class="btn btn-sm btn-white-20">
          Delete
        </button>

      </div>
    </div> <!-- / .row -->

    <!-- Close -->
    <button aria-label="Close" class="list-alert-close btn-close" type="button"></button>

  </div>

</div>